import { Page } from '../components/ui';
import {
  UnitPropertyHeader,
  UnitKpiSection,
  UnitIncomeChart,
  UnitCashflowSection,
  UnitMapBalanceSection,
  useUnitMetrics,
  useUnitSankey,
  useUnitIncomeChart,
  useUnitBalanceSheet,
} from '../features/unit-overview';
import '../css/unit-overview.css';
import '../css/chartDropdown.css';
import '../css/sankeyChart.css';
import '../css/monthRangeSlider.css';

export const UnitOverview = () => {
  const metrics = useUnitMetrics();
  const sankey = useUnitSankey();
  const income = useUnitIncomeChart();
  const balanceSheet = useUnitBalanceSheet();

  return (
    <Page className="unit-page">
      <div className="unit-layout">
        <div className="unit-layout__top">
          <UnitPropertyHeader
            unitDetails={metrics.unitDetails}
            loading={metrics.unitDetailsLoading}
            mapLocations={metrics.mapLocations}
          />
          <UnitKpiSection
            totalCost={metrics.totalCost}
            yearsHeld={metrics.yearsHeld}
            portfolioPercentage={metrics.portfolioPercentage}
            ownership={metrics.ownership}
            unitCurrency={metrics.unitCurrency}
            loading={metrics.metricsLoading}
          />
        </div>

        <div className="unit-layout__charts">
          <div className="unit-layout__charts-row">
            <UnitMapBalanceSection
              unitCurrency={metrics.unitCurrency}
              balanceSheetData={balanceSheet.stackedBarData}
              balanceSheetLoading={balanceSheet.loading}
            />
            <UnitCashflowSection
              unitCurrency={metrics.unitCurrency}
              loading={sankey.loading}
              monthsAsc={sankey.monthsAsc}
              range={sankey.range}
              nodes={sankey.nodes}
              links={sankey.links}
              onRangeChange={(startId, endId) => sankey.setRange({ startId, endId })}
            />
          </div>

          <div className="unit-layout__bottom">
            <UnitIncomeChart
              unitCurrency={metrics.unitCurrency}
              incomeYear={income.incomeYear}
              yearOptions={income.yearOptions}
              stackedBarData={income.stackedBarData}
              loading={income.loading}
              onYearChange={income.setIncomeYear}
            />
          </div>
        </div>
      </div>
    </Page>
  );
};
